import { render, staticRenderFns } from "./ElemCheck.vue?vue&type=template&id=3b38a1b2&scoped=true&"
import script from "./ElemCheck.vue?vue&type=script&lang=js&"
export * from "./ElemCheck.vue?vue&type=script&lang=js&"
import style0 from "./ElemCheck.vue?vue&type=style&index=0&id=3b38a1b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b38a1b2",
  null
  
)

export default component.exports